import { Button, Dialog, TextField } from "@mui/material";
import { ApiRequest } from "GlobalFunctions";
import { useSnackbar, withSnackbar } from "notistack";
import { useState, useEffect } from "react";
import { PiFingerprintSimple } from "react-icons/pi";

export default function LogsEditor(props: any) {
    const { enqueueSnackbar } = useSnackbar();
    const { 
        store_id, 
        getActivityLogs,
        open,
        setOpen,
     } = props;


    const [log, setLog] = useState("");

    // Clear log field when dialog opens
    useEffect(() => {
        if (open) {
            setLog("");
        }
    }, [open]);

    const addLog = () => {

        if (log.trim() === "") {
            enqueueSnackbar('Log cannot be empty', { variant: 'error' });
            return;
        }

        ApiRequest({
            url: '/stores/addLog',
            method: 'POST',
            body: {
                log: log,
                store_id: store_id,
            },
            setResponse: (response: any) => {
                if (response.status === "success") {
                    enqueueSnackbar('Log added successfully', { variant: 'success' });
                    getActivityLogs();
                    setOpen(false);
                } else {
                    enqueueSnackbar(response.message, { variant: 'error' });
                }
            }
        });
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            PaperProps={{ sx: { borderRadius: "1.25rem" } }}
            >
            <div className="DialogContainer">
                <div className="ModuleWrapper">
                    <div className="boxContainerHeader">
                        <div className="dialog_container_title">
                        <h2 className="dialog_title"><PiFingerprintSimple /> Add log</h2>
                        <h3 className="dialog_subtitle">Custom Note About Client</h3>
                        </div>
                    </div>

                    <div className="dialogFormContainer">
                        <div className='input_group'>
                            <TextField
                                value={log}
                                onChange={(e) => setLog(e.target.value)}
                                placeholder="Enter log details"
                                className="textarea"
                                multiline
                                rows={4}
                            />

                        </div>
                    </div>
                </div>
            </div>

            <div className="dialogButtons"> 
                <Button onClick={addLog} variant="contained" className="button_1">Add Log</Button>
                <Button
                    onClick={() => setOpen(false)}
                    variant="contained"
                    color="secondary"
                    className="button_secondary"
                >
                    Cancel
                </Button>
            </div>
        </Dialog>

    );
}